import { render, staticRenderFns } from "./readerPage.vue?vue&type=template&id=1a3772db&scoped=true"
import script from "./readerPage.vue?vue&type=script&lang=js"
export * from "./readerPage.vue?vue&type=script&lang=js"
import style0 from "./readerPage.vue?vue&type=style&index=0&id=1a3772db&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3772db",
  null
  
)

export default component.exports